import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

const ContactEditor = ({ data, footer, onContactChange, onFooterChange }) => {
  return (
    <div className="space-y-8">
      <div className="bg-white rounded-lg p-6 space-y-6">
        <h2 className="text-2xl font-bold text-slate-900">Contact Information</h2>
        
        <div>
          <label className="block text-sm font-medium mb-2">Section Title</label>
          <Input value={data.title} onChange={(e) => onContactChange({ ...data, title: e.target.value })} />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Subtitle</label>
          <Input value={data.subtitle} onChange={(e) => onContactChange({ ...data, subtitle: e.target.value })} />
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-2">Email</label>
            <Input value={data.email} onChange={(e) => onContactChange({ ...data, email: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Phone</label>
            <Input value={data.phone} onChange={(e) => onContactChange({ ...data, phone: e.target.value })} />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Address</label>
          <Input value={data.address} onChange={(e) => onContactChange({ ...data, address: e.target.value })} />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Google Maps Link</label>
          <Input 
            value={data.mapsLink || ''} 
            onChange={(e) => onContactChange({ ...data, mapsLink: e.target.value })} 
            placeholder="https://maps.google.com/..."
          />
          <p className="text-xs text-slate-500 mt-1">
            Paste the Google Maps link to your location. Users can click the map to open it.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Social Media Links</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium mb-1">Facebook</label>
              <Input value={data.socialMedia.facebook} onChange={(e) => onContactChange({ ...data, socialMedia: { ...data.socialMedia, facebook: e.target.value } })} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Instagram</label>
              <Input value={data.socialMedia.instagram} onChange={(e) => onContactChange({ ...data, socialMedia: { ...data.socialMedia, instagram: e.target.value } })} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">LinkedIn</label>
              <Input value={data.socialMedia.linkedin} onChange={(e) => onContactChange({ ...data, socialMedia: { ...data.socialMedia, linkedin: e.target.value } })} />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg p-6 space-y-6">
        <h2 className="text-2xl font-bold text-slate-900">Footer</h2>
        
        <div>
          <label className="block text-sm font-medium mb-2">About Text</label>
          <Textarea value={footer.about} onChange={(e) => onFooterChange({ ...footer, about: e.target.value })} rows={3} />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Disclaimer</label>
          <Textarea value={footer.disclaimer} onChange={(e) => onFooterChange({ ...footer, disclaimer: e.target.value })} rows={4} />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Copyright</label>
          <Input value={footer.copyright} onChange={(e) => onFooterChange({ ...footer, copyright: e.target.value })} />
        </div>
      </div>
    </div>
  );
};

export default ContactEditor;
